import Swiper from 'swiper'
import { Pagination, Navigation, Autoplay } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/autoplay'

export class FlexibleSlider {
  constructor() {
    this.sliders = document.querySelectorAll('.js-flexible-slider')
    if (this.sliders.length === 0) return

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.swiper.autoplay.start()
          } else {
            entry.target.swiper.autoplay.stop()
          }
        })
      },
      { root: null, threshold: 0, rootMargin: `0px 0px` },
    )

    this.resize()
  }
  initSwiper(slider) {
    const options = {
      modules: [Pagination, Navigation, Autoplay],
      slidesPerView: 'auto',
      grabCursor: true,
    }

    const container = slider.parentNode
    const buttonNext = container.querySelector('.js-slider-button.-next')
    const buttonPrev = container.querySelector('.js-slider-button.-prev')
    const progressbar = container.querySelector('.js-slider-progressbar')

    const totalSlides = slider.querySelectorAll('.swiper-slide').length

    if (buttonNext && buttonPrev) {
      options.navigation = {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      }
    }

    if (progressbar) {
      options.pagination = {
        el: progressbar,
        type: 'progressbar',
        clickable: true,
      }
    }

    if (slider.classList.contains('-autoplay')) {
      const delayData = slider.getAttribute('data-delay')
      const speedData = slider.getAttribute('data-speed')
      options.autoplay = {
        delay: delayData || 5000,
        disableOnInteraction: false,
        reverseDirection: slider.classList.contains('-reverse'),
      }
      options.speed = speedData || 500
    }

    if (slider.classList.contains('-loop')) {
      options.loop = true
      options.loopAdditionalSlides = 1
      options.initialSlide = totalSlides
      options.on = {
        init: function (swiper) {
          swiper.slideToLoop(0, 0)
        },
      }
      this.cloneSlide(slider)
    }

    if (slider.classList.contains('-center')) {
      options.centeredSlides = true
      options.normalizeSlideIndex = false
    }

    const swiper = new Swiper(slider, options)

    if (slider.classList.contains('-autoplay')) {
      this.observer.observe(swiper.el)
    }
  }
  cloneSlide(slider) {
    const slides = slider.querySelectorAll('.swiper-slide')
    slides.forEach((slide) => {
      const cloneSlide = slide.cloneNode(true)
      slider.querySelector('.swiper-wrapper').appendChild(cloneSlide)
    })
  }
  resize() {
    let timer = 0
    this.resizeObserver = new ResizeObserver((entries) => {
      if (timer > 0) {
        clearTimeout(timer)
      }
      timer = setTimeout(() => {
        this.sliders.forEach((slider) => {
          let isAct = true
          if (slider.classList.contains('-tab') && window.innerWidth >= 1024) {
            isAct = false
          } else if (slider.classList.contains('-sp') && window.innerWidth >= 768) {
            isAct = false
          }
          if (isAct === true && !slider.swiper) {
            this.initSwiper(slider)
          }
          if (isAct === false && slider.swiper) {
            slider.swiper.destroy()
          }
        })
      }, 100)
    })
    this.resizeObserver.observe(document.body)
  }
}
